import React from 'react'
import clsx from 'clsx'
import * as styles from './videocard.module.scss'
import { PlayIcon } from '../icons'

type VideoCardProps = React.ComponentProps<'div'> & {
  title: string
  url: string
}

export const VideoCard = ({ title, url, ...props }: VideoCardProps) => {
  // Function to extract the video ID from the URL
  const getVideoIdFromUrl = (url: any) => {
    const videoIdMatch = url.match(/\/embed\/([^?&]+)/)
    return videoIdMatch[1]
  }

  // Generate the YouTube thumbnail URL
  const videoId = getVideoIdFromUrl(url)
  const thumbnailUrl = videoId
    ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
    : '' // You can provide a default image URL if needed

  return (
    <div {...props}>
      <div className={clsx(styles.videocard)}>
        <div className={styles.videocard__image}>
          <img src={thumbnailUrl} alt={title} />
          <PlayIcon className={styles.videocard__playicon} size={30} />
        </div>
      </div>
      <p className={styles.videocard__title}>{title}</p>
    </div>
  )
}
